import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import styles from './AccountForm.module.scss';
import { passwordContainsNumber, passwordContainsSpecialCharacter, passwordContainsUpperAndLowerCase } from './utilities/passwordValidation';
import { useAppContext } from '../../utils/ContextProviders/AppContext';

function PasswordToolTip(props: { password: string }) {
  const { password } = props;
  const { viewSize } = useAppContext();
  return (
    <div className={`${styles.passwordTooltip} ${styles[viewSize]}`}>
      <div className={styles.triangleWithShadow} />
      <p className={styles.passwordTooltip__title}>Your password must have: </p>
      <div className={styles.passwordTooltip__row}>
        <div className={`${styles.passwordTooltip__check} ${password.length > 7 ? styles.passwordTooltip__checkValid : ''}`}>{password.length > 7 && <FontAwesomeIcon icon={faCheck} />}</div>
        <p className={styles.passwordTooltip__tip}>8 or more characters</p>
      </div>
      <div className={styles.passwordTooltip__row}>
        <div className={`${styles.passwordTooltip__check} ${passwordContainsUpperAndLowerCase(password) ? styles.passwordTooltip__checkValid : ''}`}>{passwordContainsUpperAndLowerCase(password) && <FontAwesomeIcon icon={faCheck} />}</div>
        <p className={styles.passwordTooltip__tip}>Uppercase and lowercase letters</p>
      </div>
      <div className={styles.passwordTooltip__row}>
        <div className={`${styles.passwordTooltip__check} ${passwordContainsSpecialCharacter(password) ? styles.passwordTooltip__checkValid : ''}`}>{passwordContainsSpecialCharacter(password) && <FontAwesomeIcon icon={faCheck} />}</div>
        <p className={styles.passwordTooltip__tip}>At least 1 special character(e.g.!@#$%^)</p>
      </div>
      <div className={styles.passwordTooltip__row}>
        <div className={`${styles.passwordTooltip__check} ${passwordContainsNumber(password) ? styles.passwordTooltip__checkValid : ''}`}>{passwordContainsNumber(password) && <FontAwesomeIcon icon={faCheck} />}</div>
        <p className={styles.passwordTooltip__tip}>At least 1 number</p>
      </div>
    </div>
  );
}

export default PasswordToolTip;
